import request from "@/utils/request";
import request2 from "@/utils/request2";

// 心电图api
export function getHeartVideo(id) {
  return request({
    url: "/video0/api",
    method: "get",
    params: { checkMedicalhistoryId: id }
  });
}

// 监控api
export function getCarVideo(id) {
  return request({
    url: "/video1/api",
    method: "get",
    params: { checkMedicalhistoryId: id }
  });
}

// 音频api
export function getVoice(id) {
  return request({
    url: "/wav/api",
    method: "get",
    params: {
      checkAmbulanceId: id
    }
  });
}

// 语音识别api
export function getRecognition(data) {
  return request({
    url: "/wav/api",
    method: "put",
    data
  });
}

// 语音识别api(新)
export function getRecognitionNew(data) {
  return request({
    url: "/new/version/wav/files",
    method: "post",
    data
  });
}

// 推流webrtc接口
export function startRtc(data) {
  return request2({
    url: "/rtc/v1/publish/",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    },
    transformRequest: null
  });
}

// 通过急救车的id, 获取视频播放流的token
export function getStreamToken(id) {
  return request({
    url: "/srs/play-url",
    method: "get",
    params: {
      car_id: id
    }
  });
}

// 通过急救车的id, 获取视频推流的token
export function getPushStreamToken(id) {
  return request({
    url: "/srs/get-push-token",
    method: "get",
    params: {
      car_id: id
    }
  });
}

// 通过急救车的id, 获取视频推流的token
export function getTencentToken(id) {
  return request({
    url: "/srs/tencent/sig",
    method: "get",
    params: {
      salt: id
    }
  });
}
